module.exports = __webpack_public_path__ + "15420896bdfcbf7bf6e44bdffd136050.png";